import $api from "../api";

export default class UserService {
    static async login(username, password, tgId = null) {
        const { data } = await $api.post('/user/auth', { username, password, tgId });
        return data;
    }
    static async refresh() {
        const { data } = await $api.get('/user/refresh');
        return data;
    }
    static async logout() {
        await $api.get('/user/logout');
    }
}